// extracted by mini-css-extract-plugin
module.exports = {"button":"AddViaIntercomButton_button__2W9eg","plusIcon":"AddViaIntercomButton_plusIcon__2wWd5"};